import { EditorView } from 'prosemirror-view';
import { pluginKey } from './collaborationCursorPlugin';

/**
 * Returns an object with a `destroy` method that removes the cursor session and unsubscribes listeners.
 * @param editorView The editor view to attach the plugin to.
 * @returns An object with a `destroy` method.
 * @throws An error if the plugin state is not defined.
 */
export function pluginView(editorView: EditorView) {
  const pluginState = pluginKey.getState(editorView.state);

  if (!pluginState) {
    throw new Error('Plugin state is not defined');
  }
  const {
    clientID,
    listenToRemoteCursorUpdates,
    removeCursorPositionOnDestroy,
  } = pluginState;

  // Listen to remote cursor updates
  const unsubscribe = listenToRemoteCursorUpdates({
    clientID: pluginState.clientID,
    onClientJoined: (value) =>
      editorView.dispatch(
        editorView.state.tr.setMeta('presence', { joined: [value] }),
      ),
    onClientRemoved: (value) =>
      editorView.dispatch(
        editorView.state.tr.setMeta('presence', { left: [value] }),
      ),
    onClientUpdated: (clientID, selection, version) =>
      editorView.dispatch(
        editorView.state.tr.setMeta('cursor', { clientID, selection, version }),
      ),
  });

  return {
    // update: (view: EditorView, prevState: EditorState) => {
    //   log('updating custom plugin view', view, prevState);
    // },
    destroy: () => {
      // Remove cursor session
      removeCursorPositionOnDestroy(clientID);
      // Unsubscribe listeners
      unsubscribe();
    },
  };
}
